/* eslint-disable no-useless-escape */
import React, { useState, useEffect, useRef, useContext, useMemo } from 'react';
import { Link, navigate } from 'gatsby';
import BackgroundImage from 'gatsby-background-image';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import Cookie from 'js-cookie';
import classNames  from 'classnames';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import { COOKIE_OPSWAT_REDIRECT } from '@mdc/constants';
import { Header, Footer, TextCarousel, UserContext, ScrollTopButton, CookieBanner, NetPromoterScoreManager, UploadPreloader } from '@mdc/ui';
import ScanComponent from '../scan-component/ScanComponent';
import FooterNavigation from '../footer-navigation/FooterNavigation';

import './Homepage.scss';

const HomepageCity = (props) => {
    const bgImages = props.bgImages;

    const { t, ready } = useTranslation();
    const backgroundImageRef = useRef(null);
    const [isClient, setIsClient] = useState(false);
    const userContext = useContext(UserContext);
    const direWolf = '#282828';

    const gatsbyLinks = {
        store: <Link to='/store'>{t('Store')}</Link>,
        marketShare: <Link to='/reports/anti-malware-market-share'>{t('Market Share')}</Link>,
        deepCDR: <Link to='/reports/sanitization'>{t('Deep CDR')}</Link>,
        packageEfficacy: <Link to='/reports/statistics'>{t('Package Efficacy')}</Link>,
        malwareOutbreak: <Link to='/reports/outbreak'>{t('Malware Outbreak')}</Link>,
        leaderboard: <Link to='/leaderboard'>{t('Leaderboard')}</Link>
    };

    const onLicensingClick = () => {
        navigate('/licensing');
    };

    const {
        notify,
        onFileDrop
    } = props;

    const sortAlphabetically = (a, b) => {
        if (a.node.publicURL < b.node.publicURL) { return -1; }
        if (a.node.publicURL > b.node.publicURL) { return 1; }
        return 0;
    };
    const backgrounds = bgImages.default.edges.sort(sortAlphabetically);

    const [random] = useState(() => Math.floor(Math.random() * backgrounds.length));
    const pickRandomBackgroundURL = () => {
        return {
            name: backgrounds[random].node.name,
            desktop: backgrounds[random].node.childImageSharp.fluid,
        };
    };
    const getBackgroundURL = () => {
        const backgrounds = pickRandomBackgroundURL();
        return backgrounds.desktop;

    };
    const [windowLocation, setWindowLocation] = useState({ href: '/' });
    const [backgroundImage, setBackgroundImage] = useState(getBackgroundURL);

    const headerCss = {
        container: false
    };

    let backgroundClasses = {
        'backgroundRow': true
    };

    if (isClient && backgroundImageRef.current) {
        backgroundImageRef.current.selfRef.classList.remove('gatsby-image-wrapper');
        if (pickRandomBackgroundURL().name.match(/_001/)) {
            backgroundImageRef.current.selfRef.classList.add('darken');
        }
        backgroundClasses = backgroundImageRef.current.selfRef.classList;
    }

    useEffect(() => {
        setWindowLocation(window && window.location);
        setIsClient(true);

        window.addEventListener('resize', debounce(setBackgroundImage.bind(null, getBackgroundURL), 200));
        return function cleanup() {
            window.removeEventListener('resize', debounce(setBackgroundImage.bind(null, getBackgroundURL), 200));
        };
    }, [backgroundClasses]);

    if (!ready) {
        return null;
    }

    const onSignInClicked = () => {
        if (userContext.state === userContext.STATES.LOGGED_IN) {
            return;
        }

        Cookie.set(COOKIE_OPSWAT_REDIRECT, windowLocation.href, { path: '/', secure: true });
        windowLocation.href = '/login';
    };

    const content = useMemo(() => {
        return <React.Fragment>
            <Row className='justify-content-center textCarouselWrapper'>
                <Col
                    lg={10}
                    md={12}
                    sm={12}
                    xl={10}
                >
                    <TextCarousel items={[
                        t('File'),
                        t('URL'),
                        t('IP address'),
                        t('Domain'),
                        t('HASH'),
                        t('CVE')
                    ]}
                    />

                    <ScanComponent
                        notify={notify}
                        onFileDrop={onFileDrop}
                        isFocused={true}
                    />
                </Col>
            </Row>
            <Row className='infoNoteWrapper'>
                <Col xs={{ span: 10, offset: 1 }} >
                    <div className="infoNote">
                        {t('By submitting a file to MetaDefender Cloud you are giving OPSWAT permission to share the results of your submission with the cyber security community and you are agreeing to our ')}
                        {<a href="https://onlinehelp.opswat.com/policies/OPSWAT%2C_INC._TERMS_OF_SERVICE.html" rel="noopener noreferrer" target="_blank">{t('Terms of Service')}</a>}
                        {' '}
                        {t('and')}
                        {' '}
                        {<a href="https://onlinehelp.opswat.com/policies/MetaDefender_Cloud_Privacy_Policy.html" rel="noopener noreferrer" target="_blank">{t('Privacy Policy ')}</a>}
                    </div>
                </Col>
            </Row>
        </React.Fragment>;
    }, [t]);

    const footerNavigation = <FooterNavigation/>;

    return (
        <div className="homepage">
            <Container fluid>
                <Row>
                    <div className="contentWrapper">
                        <div>
                            <BackgroundImage
                                Tag="div"
                                className={classNames(backgroundClasses)}
                                fluid={backgroundImage}
                                backgroundColor={direWolf}
                                ref={backgroundImageRef}
                            >
                            </BackgroundImage>
                            <Header
                                className={classNames(headerCss)}
                                onSignInClick={onSignInClicked}
                                onLicensingClick={onLicensingClick}
                                gatsbyLinks={gatsbyLinks}
                            />
                            <Container>
                                { content }
                            </Container>

                        </div>
                        <CookieBanner/>
                        <NetPromoterScoreManager/>
                        <Footer navigationItems={footerNavigation}/>
                    </div>
                </Row>
            </Container>
            <UploadPreloader />
            <ScrollTopButton/>
        </div>
    );

};


HomepageCity.propTypes = {
    notify: PropTypes.func,
    onFileDrop: PropTypes.func,
    bgImages: PropTypes.any.isRequired
};

export default HomepageCity;
